import { render, staticRenderFns } from "./LotLogDetails.vue?vue&type=template&id=79c87068&"
import script from "./LotLogDetails.vue?vue&type=script&lang=js&"
export * from "./LotLogDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports